import { render, staticRenderFns } from "./system-update.vue?vue&type=template&id=66135009&scoped=true&"
import script from "./system-update.vue?vue&type=script&lang=js&"
export * from "./system-update.vue?vue&type=script&lang=js&"
import style0 from "./system-update.vue?vue&type=style&index=0&id=66135009&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66135009",
  null
  
)

export default component.exports